import { render, staticRenderFns } from "./SelectStyled.vue?vue&type=template&id=132dae9a&"
import script from "./SelectStyled.vue?vue&type=script&lang=js&"
export * from "./SelectStyled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports